import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { objectValueForFields } from './object-value-for-fields.js'

export function emptyNestedFieldValue(field: SchemaField): string {
  if ((field.type === 'group' || field.type === 'section') && field.fields?.length) {
    return objectValueForFields(field.fields)
  }
  if (field.type === 'list' || field.type === 'gallery') return '[]'
  if (field.type === 'relationship' && field.multiple) return '[]'
  if (field.type === 'select' && field.multiple) return '[]'
  if (field.type === 'boolean') return 'false'
  if (field.type === 'number' || field.type === 'decimal') return field.required ? '0' : 'undefined'
  return "''"
}
